<template>
    <!-- <div>
    <section>-->
    <!-- <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" height="1000"> -->
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="promociones">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <!-- <v-container pa-2 grid-list-md class="promo-container"> -->
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold red--text text--darken-4"
                                >Promociones</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cerrar</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout row>
                            <v-flex
                                xs12
                                class="title font-weight-bold brown--text text--darken-4"
                            >Te presentamos las únicas promociones que son TODOS los días, TODO el año, ¡¡SIEMPRE!!*</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 md6>
                                <v-card max-width="80%" class="mx-auto">
                                    <v-img
                                        src="@/assets/promociones/promo1.jpg"
                                        class="align-begin"
                                        width="100%"
                                        gradient="to bottom, rgba(104,5,5,1), rgba(0,0,0,0.5)"
                                    >
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="text-center">
                                                    <v-card-title
                                                        class="white--text display-2 justify-center"
                                                    >
                                                        <div>
                                                            12 =
                                                            <span class="font-weight-bold">15%</span>
                                                        </div>
                                                    </v-card-title>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="text-center font-weight-light subtitle-1 red--text text--lighten-4"
                                                >
                                                    Compra al menos 12 botellas de
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >vino</span> y llévatelas con el
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >15% de descuento.</span>
                                                    Sin límite, sin vueltas. Además, llévate el mismo descuento en todos los productos gourmet que incluyas.
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-card max-width="80%" class="mx-auto">
                                    <v-img
                                        src="@/assets/promociones/promo2.jpg"
                                        class="align-begin"
                                        width="100%"
                                        gradient="to bottom, rgba(75,38,0,1), rgba(0,0,0,0.5)"
                                    >
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="text-center">
                                                    <v-card-title
                                                        class="white--text display-2 justify-center"
                                                    >
                                                        <div>
                                                            12 =
                                                            <span class="font-weight-bold">10%</span>
                                                        </div>
                                                    </v-card-title>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="text-center font-weight-light subtitle-1 red--text text--lighten-4"
                                                >
                                                    Compra al menos 12 botellas de
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >vino o destilados o combinadas</span> y llévatelas con el
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >10% de descuento.</span>
                                                    Sin límite, sin vueltas. Además, llévate el mismo descuento en todos los productos gourmet que incluyas.
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-center align-center>
                            <v-flex xs12 md6>
                                <v-card max-width="80%" class="mx-auto">
                                    <v-img
                                        src="@/assets/promociones/promo3.jpg"
                                        class="align-begin"
                                        width="100%"
                                        gradient="to bottom, rgba(60,0,60,1), rgba(0,0,0,0.5)"
                                    >
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="text-center">
                                                    <v-card-title
                                                        class="white--text display-2 justify-center"
                                                    >
                                                        <div>
                                                            6 =
                                                            <span class="font-weight-bold">5%</span>
                                                        </div>
                                                    </v-card-title>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="text-center font-weight-light subtitle-1 red--text text--lighten-4"
                                                >
                                                    Compra al menos 6 botellas de
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >vino o destilados o combinadas</span> y llévatelas con el
                                                    <span
                                                        class="font-weight-bold white--text"
                                                    >5% de descuento.</span>
                                                    Sin límite, sin vueltas. Además, llévate el mismo descuento en todos los productos gourmet que incluyas.
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </v-card>
                            </v-flex>
                            <!-- class="title font-weight-bold brown--text text--darken-4" -->
                            <v-flex
                                xs12
                                md6
                                class="handwritten brown--text text--darken-4"
                            >Ya lo sabes, si tienes una fiesta, una cenita o simplemente hay que rellenar la cava, ¡estas promociones son para ti!</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                class="body-2 font-weight-bold brown--text text--darken-4"
                            >*Aplican restricciones. Consulta en tienda etiquetas y productos que no participan.</v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <!-- </section> -->
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- </div> -->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'promociones',
    data() {
        return {};
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    created() {},
    computed: {
        ...mapGetters(['waitCursor', 'navMainLogo', 'platillos']),

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },
        imgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '440px';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '410px';
            } else if (this.$vuetify.breakpoint.md) {
                width = '380px';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '350px';
            } else {
                width = '320px';
            }
            return width;
        },

        breakPoint() {
            var bkPoint = 'xs';
            if (this.$vuetify.breakpoint.sm) {
                bkPoint = 'sm';
            } else if (this.$vuetify.breakpoint.md) {
                bkPoint = 'md';
            } else if (this.$vuetify.breakpoint.lg) {
                bkPoint = 'lg';
            } else if (this.$vuetify.breakpoint.xl) {
                bkPoint = 'xl';
            }
            return bkPoint;
        }
    },
    methods: {
        onClose() {
            this.$router.push('/');
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}
.promociones {
    /* background: url('../assets/maksym-kaharlytskyi-3uJt73tr4hI-unsplash1.png'); */
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}

.catabocata-red {
    /* 188,18,18 */
    color: #bc1212;
}

.mainMenu {
    font-size: 80px;
}

.promo-container {
    background: url('../assets/promociones/promo_background.jpg');

    background-size: cover;
    width: 100%;
    height: 100%;
}

.handwritten {
    font-family: secret;
    font-size: 3em;
    font-weight: normal;
    /* font-size: 2.8em; */
    /* font-size: 500px; */
}

@font-face {
    font-family: secret;
    src: url('../css/TheSecret-Regular.ttf');
}
</style>